import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { ProfissionalDetalharRoutingModule } from "./profissional-detalhar-routing.module";
import { ProfissionalDetalharComponent } from "./profissional-detalhar.component";

import { ButtonModule } from "primeng/button";
import { InputTextModule } from "primeng/inputtext";
import { DividerModule } from "primeng/divider";
import { FormsModule } from "@angular/forms";
import { TableModule } from "primeng/table";
import { InputMaskModule } from "primeng/inputmask";
import { FormatPipeModule } from "src/app/admihair/format-pipe/format-pipe.module";
import { ProgressSpinnerModule } from "primeng/progressspinner";
import { MessagesModule } from "primeng/messages";

@NgModule({
    imports: [
        CommonModule,
        ProfissionalDetalharRoutingModule,
        FormsModule,
        TableModule,
        ButtonModule,
        InputTextModule,
        DividerModule,
        InputMaskModule,
        FormatPipeModule,
        ProgressSpinnerModule,
        MessagesModule

    ],
    declarations: [ProfissionalDetalharComponent]
})
export class ProfissionalDetalharModule { }
